<template>
    <b-container fluid>
        <section class="about_us_area row" >
            <b-container fluid>
                <div class="row regDiv" style="margin-bottom:30px; padding-top:10px;">
                    <!--test block-->
                    <div class="col-md-3 crc-pad-0" >
                        
                        <div class="dash_stat4 dash_statCommon" style="height:100%">
                            <h4 class="crc_white crc-panel-heading">New Registration for S.G. Board</h4>
                            
                            <div class="dropdown dropdownNew">
                                <b-select class="mt-1" size="sm" :options="Boards" v-model="newBoard" @input="getValues" value-field="SecurityBoardID" text-field="SecurityBoardName"></b-select>
                                <hr style="margin-top: 5px;margin-bottom: 0px;"/>
                            </div>
                            <div class="row" style="padding-top:10px; text-align:center;">
                                <div class="col-md-6" >
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{form.New}}</p>
                                        <p class="crc_white" style="font-size:12px;">New Applications</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{form.Affected}}</p>
                                        <p class="crc_white" style="font-size:12px;">Affected</p>
                                    </div>
                                </div>
                                        
                                <div class="col-md-6" >
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{form.Recommended}}</p>
                                        <p class="crc_white" style="font-size:12px;">Recommended</p>
                                    </div>
                                </div>
                                    
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{form.Compassionate}}</p>
                                        <p class="crc_white" style="font-size:12px;">Compassionate</p>
                                    </div>
                                </div>
                                
                                <div class="col-md-12">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{form.CourtOrders}}</p>
                                        <p class="crc_white" style="font-size:12px;">Court Order</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row btnBlock" style="padding-top:30px;">
                                <div class="col-md-12">
                                    <button class="crc-drop-color4 crc-curve btn btn-default btn-block dropdown-toggle dropdown-padding " @click="login" type="button" id="dropdownMenu1">
                                        Login

                                    </button>
                                </div>
                            
                            </div>
                            
                        </div>
                    </div>
                
                    <div class="col-md-3 crc-pad-0">
                        <div class="dash_stat3 dash_statCommon">
                            <h4 class="crc_white crc-panel-heading" >Board's Guards & Employers</h4>
                            <div class="dropdown dropdownNew">
                                <b-select class="mt-1" size="sm" :options="Boards" v-model="existingBoard" @input="getValuesX"  
                                    value-field="SecurityBoardID" text-field="SecurityBoardName"></b-select>
                                <!-- <b-dropdown id="ddown2" text="Select Board" class="m-md-2">
                                    <b-dropdown-item>AhmadNagar District Board</b-dropdown-item>
                                    <b-dropdown-item>Amarwati District Board</b-dropdown-item>
                                    <b-dropdown-item>Aurangabad District Board</b-dropdown-item>

                                    <b-dropdown-item>Brahan Mumbai Board</b-dropdown-item>
                                    <b-dropdown-item>Chandrapur District Board</b-dropdown-item>
                                    <b-dropdown-item>Dhule District Board</b-dropdown-item>
                                
                                    <b-dropdown-item>Kolhapur District Board</b-dropdown-item>
                                    <b-dropdown-item>Nagpur District Board</b-dropdown-item>
                                
                                    <b-dropdown-item>Nashik District Board</b-dropdown-item>
                                    <b-dropdown-item>Pune District Board</b-dropdown-item>
                                    <b-dropdown-item>Raigad District Board</b-dropdown-item>
                                    
                                    <b-dropdown-item>Ratnagiri District Board</b-dropdown-item>
                                    <b-dropdown-item>Sangli District Board</b-dropdown-item>
                                    <b-dropdown-item>Solapur District Board</b-dropdown-item>

                                </b-dropdown> -->
                                <hr style="margin-top: 5px;margin-bottom: 0px;"/>
                            </div>
                            
                            <div class="row" style="padding-top:10px; text-align:center;">
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{formX.ActiveGuards}}</p>
                                        <p class="crc_white" style="font-size:12px;">Live Registered Guards</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{formX.AllotedGuards}}</p>
                                        <p class="crc_white" style="font-size:12px;">Alloted Guards</p>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">{{formX.RegisteredEmployer}}</p>
                                        <p class="crc_white" style="font-size:12px;">Registered Employers</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">--</p>
                                        <p class="crc_white" style="font-size:12px;">Exempted Agencies</p>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="crc_white" style="padding-bottom:0px; paddinsg-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">--</p>
                                        <p class="crc_white" style="font-size:12px;">Exempted Guards</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row btnBlock" style="padding-top:30px;">
                                <div class="col-md-12 ">
                                    <button class="crc-drop-color3 crc-curve btn btn-default btn-block dropdown-toggle dropdown-padding" type="button" id="dropdownMenu1">
                                        Login
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                
                    <div class="col-md-3 crc-pad-0">
                                
                        <div class="dash_stat2 dash_statCommon" >
                            <h4 class="crc_white crc-panel-heading" >Total Other Registrations</h4>
                            <div class="dropdown dropdownNew">
                            <b-select class="mt-1" size="sm" :options="Boards" v-model="regBoard" @input="getValuesReg"
                                value-field="SecurityBoardID" text-field="SecurityBoardName"></b-select>
                                <!-- <b-dropdown id="ddown3" text="Select Board" class="m-md-2">
                                    <b-dropdown-item>AhmadNagar District Board</b-dropdown-item>
                                    <b-dropdown-item>Amarwati District Board</b-dropdown-item>
                                    <b-dropdown-item>Aurangabad District Board</b-dropdown-item>

                                    <b-dropdown-item>Brahan Mumbai Board</b-dropdown-item>
                                    <b-dropdown-item>Chandrapur District Board</b-dropdown-item>
                                    <b-dropdown-item>Dhule District Board</b-dropdown-item>
                                
                                    <b-dropdown-item>Kolhapur District Board</b-dropdown-item>
                                    <b-dropdown-item>Nagpur District Board</b-dropdown-item>
                                
                                    <b-dropdown-item>Nashik District Board</b-dropdown-item>
                                    <b-dropdown-item>Pune District Board</b-dropdown-item>
                                    <b-dropdown-item>Raigad District Board</b-dropdown-item>
                                    
                                    <b-dropdown-item>Ratnagiri District Board</b-dropdown-item>
                                    <b-dropdown-item>Sangli District Board</b-dropdown-item>
                                    <b-dropdown-item>Solapur District Board</b-dropdown-item>
                                </b-dropdown> -->
                                <hr style="margin-top: 5px;margin-bottom: 0px;"/>
                            </div>
                                    
                             <div class="row" style="padding-top:10px; text-align:center;">
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p id="newPrincipalEmployers" class="crc_white" style="font-size:25px;">{{formReg.PrincipalEmployers}}</p>
                                        <p class="crc_white" style="font-size:12px;">Principal Employers</p>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p id="newAgencies" class="crc_white" style="font-size:25px;">{{formReg.Agencies}}</p>
                                        <p class="crc_white" style="font-size:12px;">Employer Agencies</p>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p id="newPrivateGuards" class="crc_white" style="font-size:25px;">{{formReg.PrivateGuards}}</p>
                                        <p class="crc_white" style="font-size:12px;">Private Guards</p>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;">0</p>
                                        <p class="crc_white" style="font-size:12px;">Exemption U/S 23</p>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="crc_white" style="padding-bottom:0px; padding-top:5px;">
                                        <p class="crc_white" style="font-size:25px;" id="nill2">&nbsp;</p>
                                        <p class="crc_white" style="font-size:12px;">&nbsp;</p>
                                    </div>
                                </div>
                            
                            </div>
                                    
                            <div class="row btnBlock" style="padding-top:30px;">
                            
                                <div class="col-md-12">
                                    <button class="crc-drop-color2 crc-curve btn btn-default btn-block dropdown-toggle dropdown-padding" @click="login" type="button" id="dropdownMenu1">
                                        Login
                                        
                                    </button>
                                </div>
                                
                            </div>

                        </div>
                    </div>
                
                    <div class="col-md-3 crc-pad-0">
                                
                        <div class="dash_stat1 dash_statCommon" style="height:100%">
                            <h4 class="crc_white crc-panel-heading">Registration</h4>
                                                     
                            
                            <div class="row btnBlock" style="padding-top:10px; text-align:center;">
                        	<div class="col-md-12">
                            	<div class="crc_white" style="padding-bottom:5px; padding-top:5px;">
                                	
                                    <button class="crc-drop-color1 crc-curve btn btn-default btn-block dropdown-toggle dropdown-padding crc-drop-color1 crc-curve"  type="button" id="dropdownMenu1" @click="signup('employer')">Principal Employers</button>
                                </div>
                            </div>
                            <div class="col-md-12">
                            	<div class="crc_white" style="padding-bottom:5px; padding-top:5px;">
                                	
                                    <button class="crc-drop-color1 crc-curve btn btn-default btn-block dropdown-toggle dropdown-padding crc-drop-color1 crc-curve"  type="button" id="dropdownMenu1" @click="signup('agency')">Employer Agencies</button>
                                </div>
                            </div>
                            
                            <!-- <div class="col-md-12">
                            	<div class="crc_white" style="padding-bottom:5px; padding-top:5px;">
                                	
                                    <button class="crc-drop-color1 crc-curve btn btn-default btn-block dropdown-toggle dropdown-padding crc-drop-color1 crc-curve"  type="button" id="dropdownMenu1" @click="signup('pvtguard')">Guards Working with Pvt Agencies</button>
                                </div>
                            </div> -->

                            <div class="col-md-12">
                            	<!-- <div class="crc_white" style="padding-bottom:5px; padding-top:5px;">
                                	
                                    <button class="crc-drop-color1 crc-curve btn btn-default btn-block dropdown-toggle dropdown-padding crc-drop-color1 crc-curve"  type="button" id="dropdownMenu1" @click="signup('newapplication')">Apply as a New Guard for Board</button>
                                </div> -->
                            </div>
                            </div>
                                    
                        </div>
                    </div>
                <!--test block-->
                </div>
        
            </b-container>
        </section>
    </b-container>
</template>

<script>
import apis from "@/apis";
export default {
  data() {
    return {
      Boards: [
        {
          SecurityBoardID: "00000000-0000-0000-0000-000000000000",
          SecurityBoardName: "All",
          BoardShortName: "ALL"
        },
        {
          SecurityBoardID: "61bbbe25-e30f-44c5-a0a8-f83dfcdf68de",
          SecurityBoardName: "Ahmadnagar District Security Guard Board",
          BoardShortName: "AMD"
        },
        {
          SecurityBoardID: "9424b61f-63d9-4390-8e99-a7db2f9a3339",
          SecurityBoardName: "Amravati District Security Guard Board",
          BoardShortName: "AMT"
        },
        {
          SecurityBoardID: "c397aa1d-82e4-4633-a302-ad34c29d739c",
          SecurityBoardName: "Aurangabad District Security Guard Board",
          BoardShortName: "ABD"
        },
        {
          SecurityBoardID: "a1bfdfd8-db30-4d39-87f7-5f2eddd7f810",
          SecurityBoardName: "Brahan Mumbai Security Guard Board",
          BoardShortName: "MUM"
        },
        {
          SecurityBoardID: "58daf6d9-454c-43c7-829d-6e35ab0d2a93",
          SecurityBoardName: "Chandrapur District Security Guard Board",
          BoardShortName: "CDP"
        },
        {
          SecurityBoardID: "8bd78a49-b6d5-4a14-91c7-87081c58bb72",
          SecurityBoardName: "Dhule District Security Guard Board",
          BoardShortName: "DHL"
        },
        {
          SecurityBoardID: "0f4e4d67-7830-41b6-a3f0-2c25ce06074c",
          SecurityBoardName: "Kolhapur District Security Guard Board",
          BoardShortName: "KOP"
        },
        {
          SecurityBoardID: "0b332344-5fa0-42ae-972c-113b285dfa3b",
          SecurityBoardName: "Nagpur District Security Guard Board",
          BoardShortName: "NGP"
        },
        {
          SecurityBoardID: "eeafb196-285d-40b6-b4fe-29ff29d5ca6f",
          SecurityBoardName: "Nashik District Security Guard Board",
          BoardShortName: "NSK"
        },
        {
          SecurityBoardID: "67bb783a-cb9d-4c38-9ab3-be54c8fbeadd",
          SecurityBoardName: "Pune District Security Guard Board",
          BoardShortName: "PUN"
        },
        {
          SecurityBoardID: "a712a1dd-d680-48d3-aa40-1de0a26347f9",
          SecurityBoardName: "Raigad District Security Guard Board",
          BoardShortName: "RGD"
        },
        {
          SecurityBoardID: "9d47f792-3dd4-4b43-abf8-1bae58881450",
          SecurityBoardName: "Ratnagiri District Security Board",
          BoardShortName: "RTN"
        },
        {
          SecurityBoardID: "3f1a3424-9960-416b-bd0a-2ddfe90fc7c6",
          SecurityBoardName: "Sangali District Security Guard Board",
          BoardShortName: "SNG"
        },
        {
          SecurityBoardID: "6658ecb2-c031-434a-8650-85e5cb30bb15",
          SecurityBoardName: "Solapur District Security Guard Board",
          BoardShortName: "SLP"
        }
      ],
      newBoard: "00000000-0000-0000-0000-000000000000",
      existingBoard: "00000000-0000-0000-0000-000000000000",
      regBoard: "00000000-0000-0000-0000-000000000000",
      formReg: {
        Board: null,
        BoardID: "00000000-0000-0000-0000-000000000000",
        Total: 0,
        New: 0,
        Affected: 0,
        Recommended: 0,
        CourtOrders: 0,
        Compassionate: 0,
        Female: 0,
        Male: 0,
        Eighth: 0,
        SSC: 0,
        HSC: 0,
        Graduate: 0,
        PostGraduate: 0,
        RegisteredGuards: 0,
        TestScheduled: 0,
        TestFailed: 0,
        ApplicationRejected: 0,
        Transactions: 0,
        FeesCollected: 0.0,
        BoardFee: 0.0,
        FeesTransferred: 0.0,
        PrivateGuards: 0,
        PrincipalEmployers: 0,
        Agencies: 0,
        TotalReg: 0,
        ActiveGuards:0,
        AllotedGuards:0,
        RegisteredEmployer:0,
        ExemptedEmployers:0,
        ExemptedGuards:0
      },
      form: {
        Board: null,
        BoardID: "00000000-0000-0000-0000-000000000000",
        Total: 0,
        New: 0,
        Affected: 0,
        Recommended: 0,
        CourtOrders: 0,
        Compassionate: 0,
        Female: 0,
        Male: 0,
        Eighth: 0,
        SSC: 0,
        HSC: 0,
        Graduate: 0,
        PostGraduate: 0,
        RegisteredGuards: 0,
        TestScheduled: 0,
        TestFailed: 0,
        ApplicationRejected: 0,
        Transactions: 0,
        FeesCollected: 0.0,
        BoardFee: 0.0,
        FeesTransferred: 0.0,
        PrivateGuards: 0,
        PrincipalEmployers: 0,
        Agencies: 0,
        TotalReg: 0
      },
      formX: {
        Board: null,
        BoardID: "00000000-0000-0000-0000-000000000000",
        Total: 0,
        New: 0,
        Affected: 0,
        Recommended: 0,
        CourtOrders: 0,
        Compassionate: 0,
        Female: 0,
        Male: 0,
        Eighth: 0,
        SSC: 0,
        HSC: 0,
        Graduate: 0,
        PostGraduate: 0,
        RegisteredGuards: 0,
        TestScheduled: 0,
        TestFailed: 0,
        ApplicationRejected: 0,
        Transactions: 0,
        FeesCollected: 0.0,
        BoardFee: 0.0,
        FeesTransferred: 0.0,
        PrivateGuards: 0,
        PrincipalEmployers: 0,
        Agencies: 0,
        TotalReg: 0
      }
    };
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    signup(typ){
        this.$router.push("/signup/"+typ);
    },
    getValues() {
      let promise = apis.getDashbord(this.newBoard);
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.form = response.body[0];
          }
        })
        .catch(err => {
          console.log("Error");
        });
    },
    getValuesReg() {
      let promise = apis.getDashbord(this.regBoard);
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.formReg = response.body[0];
          }
        })
        .catch(err => {
          console.log("Error");
        });
    },
    getValuesX() {
      let promise = apis.getDashbord(this.existingBoard);
      promise
        .then(response => {
          console.log(response);
          if (response.status == 200) {
            this.formX = response.body[0];
          }
        })
        .catch(err => {
          console.log("Error");
        });
    }
  },
  mounted() {
    this.getValues();
    this.getValuesReg();
    this.getValuesX();
  }
};
</script>

<style scoped>
.container{
    width:100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Portal/StatComponent.vue